(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-speciality', {
                parent: 'entity',
                url: '/type-speciality',
                data: {
                    authorities: [],
                    pageTitle: 'TypeSpeciality'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-speciality/list/type-speciality.html',
                        controller: 'TypeSpecialityController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Type Speciality'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY, access);
                }]
            });
    }
})();
